import script from "./Bestsellers.vue?vue&type=script&setup=true&lang=js"
export * from "./Bestsellers.vue?vue&type=script&setup=true&lang=js"

import "./Bestsellers.vue?vue&type=style&index=0&id=c40210b6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c40210b6"]])

export default __exports__